import { Loader2 } from 'lucide-react';
import React from 'react';
import { cn } from '@/lib/utils';

interface ScreenLoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  text?: React.ReactNode;
  fullScreen?: boolean;
  icon?: React.ElementType;
  size?: number;
  iconClassName?: string;
  textClassName?: string;
  children?: React.ReactNode;
}

export const ScreenLoader = ({
  className,
  text = '',
  fullScreen = false,
  icon: Icon = Loader2,
  size = 48,
  iconClassName,
  textClassName,
  children,
  ...props
}: ScreenLoaderProps) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4 text-violet-400',
        fullScreen &&
          'fixed inset-0 z-50 h-screen w-screen bg-background/80 backdrop-blur-sm animate-in fade-in zoom-in-95 duration-200',
        className,
      )}
      {...props}
    >
      <Icon className={cn('animate-spin', iconClassName)} size={size} />

      {(text || children) && (
        <div
          className={cn(
            'font-medium tracking-tight animate-pulse',
            textClassName,
          )}
        >
          {text}
          {children}
        </div>
      )}
    </div>
  );
};
